import Vue from 'vue';
import * as firebase from 'firebase/app';

// init
if (!firebase.apps.length) {
  firebase.initializeApp({
    apiKey: 'AIzaSyAvcwuDNB6zPJ-dbl3LdAhbrndGqd1leNU',
    authDomain: 'honkoku2.firebaseapp.com',
    databaseURL: 'https://honkoku2.firebaseio.com',
    projectId: 'honkoku2',
    storageBucket: 'honkoku2.appspot.com',
    messagingSenderId: '843493361085',
  });
}
import 'firebase/auth';
import 'firebase/firestore';
import { firestorePlugin } from 'vuefire';

firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);

// vuefire
Vue.use(firestorePlugin);
export default firebase;
export const db = firebase.firestore();
